var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container feedback template-bg-gray comm-req-page" },
    [
      _vm.showNotFound
        ? _c("NotFound", { attrs: { community_id: _vm.community_id } })
        : _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "loop_container bg-transparent update-request-form-common"
                  },
                  [
                    _c("div", { staticClass: "card form-wrapper" }, [
                      _c(
                        "div",
                        {
                          staticClass: "feedback_container feedback_newupdate"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _vm.isShow
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-12 text-center" },
                                    [
                                      _c("img", {
                                        staticClass: "top-logo custom-logo",
                                        attrs: {
                                          src: _vm.logoURL,
                                          alt:
                                            "Community Logo of " +
                                            (_vm.community &&
                                            _vm.community.content &&
                                            _vm.community.content.parameter4
                                              ? _vm.community.content.parameter4
                                              : (_vm.community &&
                                                  _vm.community.name) ||
                                                "Community")
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("CustomSkeleton", {
                                attrs: { "is-visible": !_vm.isShow }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isBeforeRequest && _vm.showFormFlag && _vm.isShow
                            ? [
                                _c("div", {}, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tab-content",
                                      attrs: { id: "myTabContent" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isFirstPage,
                                              expression: "isFirstPage"
                                            }
                                          ],
                                          staticClass: "tab_inn",
                                          attrs: { id: "about-you" }
                                        },
                                        [
                                          _c(
                                            "h1",
                                            {
                                              staticClass: "template-title",
                                              attrs: { id: "main-header" }
                                            },
                                            [
                                              _vm._v(
                                                "Tell us a bit about yourself"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.community.content &&
                                          _vm.community.content
                                            .requestIntroduction
                                            ? _c("p", {
                                                staticClass:
                                                  "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.community.content
                                                      .requestIntroduction
                                                  )
                                                }
                                              })
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "box-sub-heading mb35 custom-content request-form-title-anchor-tab"
                                                },
                                                [
                                                  _vm._v(
                                                    "We need a little bit of information to match you to relevant experts in the community."
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "form",
                                            {
                                              staticClass: "template-form",
                                              attrs: {
                                                "data-vv-scope": "step-1"
                                              },
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.viewSecondPage(
                                                    "step-1"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "required-note template-label",
                                                  attrs: { id: "required-note" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                Fields marked with an asterisk ("
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-symbol"
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    ") are required.\n                                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row responsive-v3-class"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for: "firstName"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .configureFields
                                                                    .firstName
                                                                    .labelName
                                                                )
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "required-symbol"
                                                                },
                                                                [_vm._v(" *")]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.ask.first,
                                                                expression:
                                                                  "ask.first"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            ref: "firstName",
                                                            staticClass:
                                                              "form-control input-value pt-input input-focus",
                                                            class: {
                                                              "request-form-error-border": _vm.errors.has(
                                                                "step-1.first"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id: "firstName",
                                                              name: "first",
                                                              autocomplete:
                                                                "given-name",
                                                              placeholder: "",
                                                              required: "",
                                                              "data-vv-validate-on":
                                                                "change",
                                                              "aria-required":
                                                                "true",
                                                              "aria-describedby":
                                                                "required-note"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.ask.first
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.ask,
                                                                    "first",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                function(e) {
                                                                  return (_vm.ask.first = _vm.sanitizeInput(
                                                                    e.target
                                                                      .value
                                                                  ))
                                                                }
                                                              ]
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.first"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.first')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "step-1.first"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for: "lastName"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .configureFields
                                                                    .lastName
                                                                    .labelName
                                                                )
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "required-symbol"
                                                                },
                                                                [_vm._v(" *")]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.ask.last,
                                                                expression:
                                                                  "ask.last"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control input-value pt-input input-focus",
                                                            class: {
                                                              "request-form-error-border": _vm.errors.has(
                                                                "step-1.last"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id: "lastName",
                                                              name: "last",
                                                              autocomplete:
                                                                "family-name",
                                                              placeholder: "",
                                                              required: "",
                                                              "data-vv-validate-on":
                                                                "change",
                                                              "aria-required":
                                                                "true",
                                                              "aria-describedby":
                                                                "required-note"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.ask.last
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.ask,
                                                                    "last",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                function(e) {
                                                                  return (_vm.ask.last = _vm.sanitizeInput(
                                                                    e.target
                                                                      .value
                                                                  ))
                                                                }
                                                              ]
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.last"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.last')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "step-1.last"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for: "email"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .configureFields
                                                                    .emailAddress
                                                                    .labelName
                                                                )
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "required-symbol"
                                                                },
                                                                [_vm._v(" *")]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.ask.email,
                                                                expression:
                                                                  "ask.email"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate.continues",
                                                                value:
                                                                  "required|email",
                                                                expression:
                                                                  "'required|email'",
                                                                modifiers: {
                                                                  continues: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control input-value pt-input input-focus",
                                                            class: {
                                                              "request-form-error-border": _vm.errors.has(
                                                                "step-1.email"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "email",
                                                              id: "email",
                                                              autocomplete:
                                                                "email",
                                                              name: "email",
                                                              placeholder: "",
                                                              "data-vv-validate-on":
                                                                "change",
                                                              required: "",
                                                              "aria-required":
                                                                "true",
                                                              "aria-describedby":
                                                                "required-note"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.ask.email
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.checkMemberStatus,
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.ask,
                                                                    "email",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                function(e) {
                                                                  return (_vm.ask.email = _vm.sanitizeInput(
                                                                    e.target
                                                                      .value
                                                                  ))
                                                                }
                                                              ]
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.email"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.email')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                                    " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "step-1.email"
                                                                    )
                                                                  ) +
                                                                  "\n                                                                "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .memberRole &&
                                                  _vm.configureFields.memberRole
                                                    .include &&
                                                  _vm.configureFields.memberRole
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "memberRole"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .memberRole
                                                                        .labelName
                                                                    ) + " "
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "memberRole"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate.continues",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "memberRole"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('memberRole')}`",
                                                                      modifiers: {
                                                                        continues: true
                                                                      }
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .memberRole,
                                                                      expression:
                                                                        "dynamicFields.memberRole"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  class: {
                                                                    "request-form-error-border": _vm.errors.has(
                                                                      "step-1.memberRole"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    "data-vv-validate-on":
                                                                      "change|blur",
                                                                    name:
                                                                      "memberRole",
                                                                    id:
                                                                      "memberRole",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "memberRole"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "aria-describedby": _vm.checkAndValidate1(
                                                                      "memberRole"
                                                                    )
                                                                      ? "required-note"
                                                                      : null
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "memberRole",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select role"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .memberRole
                                                                      .memberValue,
                                                                    function(
                                                                      role
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key: role,
                                                                          domProps: {
                                                                            value: role.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              role.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.memberRole"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.memberRole')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.memberRole"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .phoneNumber &&
                                                  _vm.configureFields
                                                    .phoneNumber.include &&
                                                  _vm.configureFields
                                                    .phoneNumber.include ===
                                                    true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "template-label",
                                                                          attrs: {
                                                                            for:
                                                                              "phoneNumber"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .configureFields
                                                                                .phoneNumber
                                                                                .labelName
                                                                            ) +
                                                                              " "
                                                                          ),
                                                                          _vm.checkAndValidate1(
                                                                            "phoneNumber"
                                                                          )
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "required-symbol"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " *"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .dynamicFields
                                                                                  .phoneNumber,
                                                                              expression:
                                                                                "dynamicFields.phoneNumber"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate.continues",
                                                                              value:
                                                                                "" +
                                                                                _vm.checkAndValidate1(
                                                                                  "phoneNumber"
                                                                                ),
                                                                              expression:
                                                                                "`${checkAndValidate1('phoneNumber')}`",
                                                                              modifiers: {
                                                                                continues: true
                                                                              }
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-control input-value pt-input input-focus",
                                                                          class: {
                                                                            "request-form-error-border": _vm.errors.has(
                                                                              "step-1.phoneNumber"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            id:
                                                                              "phoneNumber",
                                                                            name:
                                                                              "phoneNumber",
                                                                            "data-vv-validate-on":
                                                                              "change",
                                                                            "aria-required": _vm.checkAndValidate1(
                                                                              "phoneNumber"
                                                                            )
                                                                              ? "true"
                                                                              : "false",
                                                                            "aria-describedby": _vm.checkAndValidate1(
                                                                              "phoneNumber"
                                                                            )
                                                                              ? "required-note"
                                                                              : null
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              _vm
                                                                                .dynamicFields
                                                                                .phoneNumber
                                                                          },
                                                                          on: {
                                                                            input: [
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm.dynamicFields,
                                                                                  "phoneNumber",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              },
                                                                              function(
                                                                                e
                                                                              ) {
                                                                                return (_vm.dynamicFields.phoneNumber = _vm.sanitizeInput(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                ))
                                                                              }
                                                                            ]
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value: _vm.errors.has(
                                                                                "step-1.phoneNumber"
                                                                              ),
                                                                              expression:
                                                                                "errors.has('step-1.phoneNumber')"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "error"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.errors.first(
                                                                                "step-1.phoneNumber"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .adviceArea &&
                                                  _vm.configureFields.adviceArea
                                                    .include &&
                                                  _vm.configureFields.adviceArea
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "adviceArea"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .adviceArea
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "adviceArea"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "adviceArea"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('adviceArea')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .adviceArea,
                                                                      expression:
                                                                        "dynamicFields.adviceArea"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    "data-vv-validate-on":
                                                                      "change|blur",
                                                                    name:
                                                                      "adviceArea",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "adviceArea"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    id:
                                                                      "adviceArea",
                                                                    "aria-describedby": _vm.checkAndValidate1(
                                                                      "adviceArea"
                                                                    )
                                                                      ? "required-note"
                                                                      : null
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "adviceArea",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select Area"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .adviceArea
                                                                      .memberValue,
                                                                    function(
                                                                      role
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key: role,
                                                                          domProps: {
                                                                            value: role.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              role.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.adviceArea"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.adviceArea')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.adviceArea"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .linkedInProfile &&
                                                  _vm.configureFields
                                                    .linkedInProfile.include &&
                                                  _vm.configureFields
                                                    .linkedInProfile.include ===
                                                    true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "linkedInProfile"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .linkedInProfile
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "linkedInProfile"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .linkedInProfile,
                                                                    expression:
                                                                      "dynamicFields.linkedInProfile"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value: {
                                                                      required:
                                                                        _vm
                                                                          .configureFields
                                                                          .linkedInProfile
                                                                          .require ==
                                                                        true
                                                                          ? true
                                                                          : false,
                                                                      regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                                                    },
                                                                    expression:
                                                                      "{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "linkedInProfile"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "linkedInProfile"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "linkedInProfile"
                                                                  )
                                                                    ? "required-note"
                                                                    : null,
                                                                  id:
                                                                    "linkedInProfile",
                                                                  name:
                                                                    "linkedInProfile",
                                                                  "data-vv-validate-on":
                                                                    "change"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .linkedInProfile
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "linkedInProfile",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.linkedInProfile = _vm.sanitizeUrl(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.linkedInProfile"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.linkedInProfile')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.linkedInProfile"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.college &&
                                                  _vm.configureFields.college
                                                    .include &&
                                                  _vm.configureFields.college
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "college"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .college
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "college"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .college,
                                                                    expression:
                                                                      "dynamicFields.college"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "college"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('college')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.college"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "college",
                                                                  name:
                                                                    "college",
                                                                  "data-vv-validate-on":
                                                                    "change",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "college"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "college"
                                                                  )
                                                                    ? "required-note"
                                                                    : null
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .college
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "college",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.college = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.college"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.college')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.college"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .college2 &&
                                                  _vm.configureFields.college2
                                                    .include &&
                                                  _vm.configureFields.college2
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "college2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .college2
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "college2"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "college2"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('college2')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .college2,
                                                                      expression:
                                                                        "dynamicFields.college2"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    id:
                                                                      "college2",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "college2"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "data-vv-validate-on":
                                                                      "change|blur",
                                                                    "aria-describedby": _vm.checkAndValidate1(
                                                                      "college2"
                                                                    )
                                                                      ? "required-note"
                                                                      : null,
                                                                    name:
                                                                      "college2"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "college2",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .configureFields
                                                                              .college2
                                                                              .labelName
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm.college2
                                                                      .memberValue,
                                                                    function(
                                                                      degree,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "college-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: degree.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              degree.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.college2"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.college2')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.college2"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.major &&
                                                  _vm.configureFields.major
                                                    .include &&
                                                  _vm.configureFields.major
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "major"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .major
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "major"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.selectedMajorTemp,
                                                                      expression:
                                                                        "selectedMajorTemp"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    id: "major",
                                                                    name:
                                                                      "majorSelect",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "major"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "data-vv-validate-on":
                                                                      "change|blur"
                                                                  },
                                                                  on: {
                                                                    change: [
                                                                      function(
                                                                        $event
                                                                      ) {
                                                                        var $$selectedVal = Array.prototype.filter
                                                                          .call(
                                                                            $event
                                                                              .target
                                                                              .options,
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              return o.selected
                                                                            }
                                                                          )
                                                                          .map(
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              var val =
                                                                                "_value" in
                                                                                o
                                                                                  ? o._value
                                                                                  : o.value
                                                                              return val
                                                                            }
                                                                          )
                                                                        _vm.selectedMajorTemp = $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      },
                                                                      _vm.onMajorSelect
                                                                    ]
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .configureFields
                                                                              .major
                                                                              .labelName
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm.major
                                                                      .memberValue,
                                                                    function(
                                                                      m,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "major-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: m.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              m.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "major"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('major')}`"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  type:
                                                                    "hidden",
                                                                  name: "major",
                                                                  "data-vv-validate-on":
                                                                    "change|blur",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "major"
                                                                  )
                                                                    ? "required-note"
                                                                    : null
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.majorJoined
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.major"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.major')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.major"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.dynamicFields
                                                                .major &&
                                                              _vm.dynamicFields
                                                                .major.length
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "selected-chips"
                                                                    },
                                                                    _vm._l(
                                                                      _vm
                                                                        .dynamicFields
                                                                        .major,
                                                                      function(
                                                                        m
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          {
                                                                            key:
                                                                              "major-chip-" +
                                                                              m,
                                                                            staticClass:
                                                                              "chip"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                m
                                                                              ) +
                                                                                "\n                                                                      "
                                                                            ),
                                                                            _c(
                                                                              "button",
                                                                              {
                                                                                staticClass:
                                                                                  "chip-close",
                                                                                attrs: {
                                                                                  type:
                                                                                    "button",
                                                                                  "aria-label":
                                                                                    "Remove " +
                                                                                    m
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    $event.stopPropagation()
                                                                                    return _vm.removeMajorByValue(
                                                                                      m
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "×"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .classYear &&
                                                  _vm.configureFields.classYear
                                                    .include &&
                                                  _vm.configureFields.classYear
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "year"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .classYear
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "year"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .year,
                                                                    expression:
                                                                      "dynamicFields.year"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "year"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('year')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.year"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "year",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "year"
                                                                  )
                                                                    ? "required-note"
                                                                    : null,
                                                                  name: "year",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "year"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  "data-vv-validate-on":
                                                                    "change"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .year
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "year",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.year = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.year"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.year')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.year"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .classYear2 &&
                                                  _vm.configureFields.classYear2
                                                    .include &&
                                                  _vm.configureFields.classYear2
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "year2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .classYear2
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "year2"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "year2"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('year2')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .year2,
                                                                      expression:
                                                                        "dynamicFields.year2"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    id: "year2",
                                                                    "data-vv-validate-on":
                                                                      "change|blur",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "year2"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "aria-describedby": _vm.checkAndValidate1(
                                                                      "year2"
                                                                    )
                                                                      ? "required-note"
                                                                      : null,
                                                                    name:
                                                                      "year2"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "year2",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .configureFields
                                                                              .classYear2
                                                                              .labelName
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .classYear2
                                                                      .memberValue,
                                                                    function(
                                                                      year,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "year-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: year.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              year.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.year2"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.year2')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.year2"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .organization &&
                                                  _vm.configureFields
                                                    .organization.include &&
                                                  _vm.configureFields
                                                    .organization.include ===
                                                    true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "organization"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .organization
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "organization"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .organization,
                                                                    expression:
                                                                      "dynamicFields.organization"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "organization"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('organization')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.organization"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "organization",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "organization"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  name:
                                                                    "organization",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "organization"
                                                                  )
                                                                    ? "required-note"
                                                                    : null,
                                                                  "data-vv-validate-on":
                                                                    "change"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .organization
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "organization",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.organization = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.organization"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.organization')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.organization"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.title &&
                                                  _vm.configureFields.title
                                                    .include &&
                                                  _vm.configureFields.title
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "role"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .title
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "role"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .role,
                                                                    expression:
                                                                      "dynamicFields.role"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "role"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('role')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.role"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "role",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "role"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  name: "role",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "role"
                                                                  )
                                                                    ? "required-note"
                                                                    : null,
                                                                  "data-vv-validate-on":
                                                                    "change"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .role
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "role",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.role = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.role"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.role')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.role"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .studentId &&
                                                  _vm.configureFields.studentId
                                                    .include &&
                                                  _vm.configureFields.studentId
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "studentId"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .studentId
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "studentId"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .studentId,
                                                                    expression:
                                                                      "dynamicFields.studentId"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "studentId"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('studentId')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.studentId"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "studentId",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "studentId"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  name:
                                                                    "studentId",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "studentId"
                                                                  )
                                                                    ? "required-note"
                                                                    : null,
                                                                  "data-vv-validate-on":
                                                                    "change"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .studentId
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "studentId",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.studentId = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.studentId"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.studentId')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.studentId"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.dueDate &&
                                                  _vm.configureFields.dueDate
                                                    .include &&
                                                  _vm.configureFields.dueDate
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "dueDate"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .dueDate
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "dueDate"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("datepicker", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "dueDate"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('dueDate')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "input-focus template-input-date-picker",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.dueDate"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  id: "dueDate",
                                                                  name:
                                                                    "dueDate",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "dueDate"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "dueDate"
                                                                  )
                                                                    ? "required-note"
                                                                    : null,
                                                                  format:
                                                                    _vm.DatePickerFormat,
                                                                  disabledDates:
                                                                    _vm.disabledDates,
                                                                  "data-vv-validate-on":
                                                                    "change|blur"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .dueDate,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.dynamicFields,
                                                                      "dueDate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "dynamicFields.dueDate"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "helper-text template-label mb-0-custom"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      "Note:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " Does your request have an expiration date after which an answer is no longer desirable?"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.dueDate"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.dueDate')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.dueDate"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .referrer &&
                                                  _vm.configureFields.referrer
                                                    .include &&
                                                  _vm.configureFields.referrer
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "referrer"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .referrer
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "referrer"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .referrer,
                                                                    expression:
                                                                      "dynamicFields.referrer"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "referrer"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('referrer')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.referrer"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "referrer",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "referrer"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  name:
                                                                    "referrer",
                                                                  placeholder:
                                                                    "",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "referrer"
                                                                  )
                                                                    ? "required-note"
                                                                    : null,
                                                                  "data-vv-validate-on":
                                                                    "change"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .referrer
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "referrer",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.referrer = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.referrer"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.referrer')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.referrer"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .referrer2 &&
                                                  _vm.configureFields.referrer2
                                                    .include &&
                                                  _vm.configureFields.referrer2
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "referrer2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .referrer2
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "referrer2"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "referrer2"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('referrer2')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .referrer2,
                                                                      expression:
                                                                        "dynamicFields.referrer2"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    id:
                                                                      "referrer2",
                                                                    "data-vv-validate-on":
                                                                      "change|blur",
                                                                    "aria-describedby": _vm.checkAndValidate1(
                                                                      "referrer2"
                                                                    )
                                                                      ? "required-note"
                                                                      : null,
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "referrer2"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    name:
                                                                      "referrer2"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "referrer2",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .referrer2
                                                                      .memberValue,
                                                                    function(
                                                                      degree,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "referrer-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: degree.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              degree.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.referrer2"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.referrer2')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.referrer2"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.configureFields.disclaimer &&
                                              _vm.configureFields.dueDate
                                                .include === false
                                                ? _c("div", {
                                                    staticClass:
                                                      "template-mb-35"
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "responsive-v3-class",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                    "justify-content":
                                                      "space-between",
                                                    "flex-wrap": "wrap"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "button-container",
                                                      staticStyle: {
                                                        "margin-left": "auto"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "btn_info template-review-submit template-button",
                                                          style:
                                                            _vm.styleSubmitBtn,
                                                          attrs: {
                                                            type: "submit"
                                                          },
                                                          on: {
                                                            click: _vm.onClick
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                        Next\n                                                        "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isSecondPage
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "tab_inn",
                                              attrs: { id: "your-question" }
                                            },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title"
                                                },
                                                [
                                                  _vm._v(
                                                    "What do you need help with?"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.community.content &&
                                              _vm.community.content
                                                .requestFormWizardPage2
                                                ? _c("p", {
                                                    staticClass:
                                                      "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.community.content
                                                          .requestFormWizardPage2
                                                      )
                                                    }
                                                  })
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                      attrs: {
                                                        "aria-live": "polite"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "A great question will get you great answers (and connections). Here's a "
                                                      ),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "https://storage.googleapis.com/protopia/images/How%20to%20ask%20a%20question.mp4",
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Short video on how to craft one."
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c(
                                                "form",
                                                {
                                                  staticClass: "template-form",
                                                  attrs: {
                                                    "data-vv-scope": "step-2"
                                                  },
                                                  on: {
                                                    submit: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.viewThirdPage(
                                                        "step-2"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col",
                                                          style:
                                                            _vm.magicWandThemeStyle
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "title",
                                                                    id:
                                                                      "label-short-headline"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                                Short headline "
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required-symbol"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " *"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    ":\n                                                                "
                                                                  ),
                                                                  _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        "aria-live":
                                                                          "polite",
                                                                        isInteractive: true,
                                                                        content:
                                                                          "No more than three to four keywords that summarize the request and catch the reader's attention. For example: 'Consulting career' or 'Moving to Japan'."
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                      attrs: {
                                                                        id:
                                                                          "headline-description"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Short headline tooltip: No more than three to four keywords that summarize the request and catch the reader's attention. For example: 'Consulting career' or 'Moving to Japan'."
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-2.title"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-2.title')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error-message error-for-textarea"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-2.title"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "char-counter-input"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "char-counter-headline",
                                                                        "aria-live":
                                                                          "polite"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.subjectCount
                                                                        ) +
                                                                          " / " +
                                                                          _vm._s(
                                                                            _vm.subjectMax
                                                                          )
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "sr-only"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " character count "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "magic-wand-field-input magic-wand-icon"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model.trim",
                                                                        value:
                                                                          _vm
                                                                            .ask
                                                                            .subject,
                                                                        expression:
                                                                          "ask.subject",
                                                                        modifiers: {
                                                                          trim: true
                                                                        }
                                                                      },
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required|min:10|max:100",
                                                                        expression:
                                                                          "'required|min:10|max:100'"
                                                                      }
                                                                    ],
                                                                    ref:
                                                                      "subjectMagicWand",
                                                                    staticClass:
                                                                      "form-control input-value input-focus pr16",
                                                                    class: {
                                                                      "request-form-error-border": _vm.errors.has(
                                                                        "step-2.title"
                                                                      )
                                                                    },
                                                                    attrs: {
                                                                      tabindex:
                                                                        "0",
                                                                      type:
                                                                        "text",
                                                                      "aria-labelledby":
                                                                        "label-short-headline char-counter-headline",
                                                                      "aria-describedby":
                                                                        "char-counter-headline",
                                                                      id:
                                                                        "title",
                                                                      name:
                                                                        "title",
                                                                      required:
                                                                        "",
                                                                      "aria-required":
                                                                        "true",
                                                                      maxlength:
                                                                        _vm.subjectMax,
                                                                      "data-vv-validate-on":
                                                                        "change|blur|input"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.ask
                                                                          .subject
                                                                    },
                                                                    on: {
                                                                      keyup: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.countdown(
                                                                          "subject"
                                                                        )
                                                                      },
                                                                      keydown: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          !$event.type.indexOf(
                                                                            "key"
                                                                          ) &&
                                                                          _vm._k(
                                                                            $event.keyCode,
                                                                            "enter",
                                                                            13,
                                                                            $event.key,
                                                                            "Enter"
                                                                          )
                                                                        ) {
                                                                          return null
                                                                        }
                                                                        return _vm.moveToNextTooltip.apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      },
                                                                      focus: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleFocusChange(
                                                                          $event
                                                                        )
                                                                      },
                                                                      input: [
                                                                        function(
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm.ask,
                                                                            "subject",
                                                                            $event.target.value.trim()
                                                                          )
                                                                        },
                                                                        function(
                                                                          e
                                                                        ) {
                                                                          return (_vm.ask.subject = _vm.sanitizeInput(
                                                                            e
                                                                              .target
                                                                              .value
                                                                          ))
                                                                        }
                                                                      ],
                                                                      blur: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _vm.enableMagicWandLF
                                                                    ? _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "magic-wand-link-lw magic-wand-link-accent",
                                                                          class: {
                                                                            "magic-wand-link-active": _vm.isExamplesOpen(
                                                                              "subject"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            role:
                                                                              "button",
                                                                            "aria-label":
                                                                              "View Examples",
                                                                            href:
                                                                              "javascript:void(0);"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              $event.preventDefault()
                                                                              return _vm.toggleMagicWandExamples(
                                                                                "subject"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " View Examples\n                                                                    "
                                                                          ),
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "magic-wand-img magic-wand-img-panel",
                                                                              attrs: {
                                                                                src:
                                                                                  _vm.magicWandIcon,
                                                                                alt:
                                                                                  "",
                                                                                width:
                                                                                  "20",
                                                                                height:
                                                                                  "20"
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.enableMagicWandLF &&
                                                          _vm.isExamplesOpen(
                                                            "subject"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "magic-wand-examples-anchor"
                                                                },
                                                                [
                                                                  _c(
                                                                    "MagicWandExamplesPanel",
                                                                    {
                                                                      attrs: {
                                                                        examples: _vm.getWizardExamplesForField(
                                                                          "subject"
                                                                        ),
                                                                        "field-label": _vm.getMagicWandFieldLabel(
                                                                          "subject"
                                                                        ),
                                                                        loading:
                                                                          _vm.wizardExamplesLoading,
                                                                        "magic-wand-icon":
                                                                          _vm.magicWandIcon,
                                                                        "accent-color":
                                                                          _vm.magicWandAccentColor,
                                                                        "field-has-text": _vm.magicWandFieldHasText(
                                                                          "subject"
                                                                        )
                                                                      },
                                                                      on: {
                                                                        close:
                                                                          _vm.closeMagicWandExamples,
                                                                        "use-example": function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.insertMagicWandExample(
                                                                            "subject",
                                                                            $event
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col",
                                                          style:
                                                            _vm.magicWandThemeStyle
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group template-input-text-area template-textarea-v3-t1 magic-wand-icon"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "bio",
                                                                    id:
                                                                      "label-brief-intro"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                                Briefly introduce yourself "
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required-symbol"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " *"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    ":\n                                                                "
                                                                  ),
                                                                  _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        "aria-live":
                                                                          "polite",
                                                                        isInteractive: true,
                                                                        content:
                                                                          "One or two sentences on who you are and that you are a part of the community. For example: I'm a rising junior majoring in [major] at [school]."
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                      attrs: {
                                                                        id:
                                                                          "introduction-description"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Briefly introduce yourself tooltip: One or two sentences on who you are and that you are a part of the community. For example: I'm a rising junior majoring in [major] at [school]."
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-2.bio"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-2.bio')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error-message-textarea error-for-textarea"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-2.bio"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "char-counter-input"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "char-counter-introduction",
                                                                        "aria-live":
                                                                          "polite"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.bioCount
                                                                        ) +
                                                                          " / " +
                                                                          _vm._s(
                                                                            _vm.bioMax
                                                                          )
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "sr-only"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " character count "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("textarea", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model.trim",
                                                                    value:
                                                                      _vm.ask
                                                                        .bio,
                                                                    expression:
                                                                      "ask.bio",
                                                                    modifiers: {
                                                                      trim: true
                                                                    }
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "required|max:500|min:100",
                                                                    expression:
                                                                      "'required|max:500|min:100'",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                ref:
                                                                  "bioMagicWand",
                                                                staticClass:
                                                                  "form-control pt-input field_1",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-2.bio"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  "aria-labelledby":
                                                                    "label-brief-intro char-counter-introduction",
                                                                  "aria-describedby":
                                                                    "char-counter-introduction",
                                                                  id: "bio",
                                                                  name: "bio",
                                                                  required: "",
                                                                  "aria-required":
                                                                    "true",
                                                                  maxlength:
                                                                    _vm.bioMax,
                                                                  "data-vv-validate-on":
                                                                    "change|blur|input",
                                                                  rows: "3"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.ask.bio
                                                                },
                                                                on: {
                                                                  keyup: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.countdown(
                                                                      "bio"
                                                                    )
                                                                  },
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.ask,
                                                                        "bio",
                                                                        $event.target.value.trim()
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.ask.bio = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ],
                                                                  focus: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleFocusChange(
                                                                      $event
                                                                    )
                                                                  },
                                                                  blur: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _vm.enableMagicWandLF
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "magic-wand-link-textarea-lw magic-wand-link-accent",
                                                                      class: {
                                                                        "magic-wand-link-active": _vm.isExamplesOpen(
                                                                          "bio"
                                                                        )
                                                                      },
                                                                      attrs: {
                                                                        role:
                                                                          "button",
                                                                        "aria-label":
                                                                          "View Examples",
                                                                        href:
                                                                          "javascript:void(0);"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.toggleMagicWandExamples(
                                                                            "bio"
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " View Examples\n                                                                "
                                                                      ),
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "magic-wand-img magic-wand-img-panel",
                                                                          attrs: {
                                                                            src:
                                                                              _vm.magicWandIcon,
                                                                            alt:
                                                                              "",
                                                                            width:
                                                                              "20",
                                                                            height:
                                                                              "20"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.enableMagicWandLF &&
                                                          _vm.isExamplesOpen(
                                                            "bio"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "magic-wand-examples-anchor"
                                                                },
                                                                [
                                                                  _c(
                                                                    "MagicWandExamplesPanel",
                                                                    {
                                                                      attrs: {
                                                                        examples: _vm.getWizardExamplesForField(
                                                                          "bio"
                                                                        ),
                                                                        "field-label": _vm.getMagicWandFieldLabel(
                                                                          "bio"
                                                                        ),
                                                                        loading:
                                                                          _vm.wizardExamplesLoading,
                                                                        "magic-wand-icon":
                                                                          _vm.magicWandIcon,
                                                                        "accent-color":
                                                                          _vm.magicWandAccentColor,
                                                                        "field-has-text": _vm.magicWandFieldHasText(
                                                                          "bio"
                                                                        )
                                                                      },
                                                                      on: {
                                                                        close:
                                                                          _vm.closeMagicWandExamples,
                                                                        "use-example": function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.insertMagicWandExample(
                                                                            "bio",
                                                                            $event
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col",
                                                          style:
                                                            _vm.magicWandThemeStyle
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group template-input-text-area template-textarea-v3-t2 magic-wand-icon"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "message",
                                                                    "aria-label":
                                                                      "What do you need help with?."
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "What do you need help with? "
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required-symbol"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " *"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    ":\n                                                                "
                                                                  ),
                                                                  _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        "aria-live":
                                                                          "polite",
                                                                        isInteractive: true,
                                                                        content:
                                                                          "Make sure to 1) make it very clear WHAT you need help with, 2) WHY you want advice / guidance and 3) explain HOW help will make a difference. Keep it at no more than 2 paragraphs so that it’s easy to determine for the reader if she can assist. Great questions are clear, brief and personal."
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                      attrs: {
                                                                        id:
                                                                          "help-description"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "What do you need help with? tooltip: Make sure to 1.- make it very clear WHAT you need help with, 2.- WHY you want advice / guidance and 3.- explain HOW help will make a difference. Keep it at no more than 2 paragraphs so that it’s easy to determine for the reader if she can assist. Great questions are clear, brief and personal."
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-2.message"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-2.message')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error-message-textarea error-for-textarea"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-2.message"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "char-counter-input"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "char-counter-help",
                                                                        "aria-live":
                                                                          "polite"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.textCount
                                                                        ) +
                                                                          " / " +
                                                                          _vm._s(
                                                                            _vm.textMax
                                                                          )
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "sr-only"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " character count "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("textarea", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model.trim",
                                                                    value:
                                                                      _vm.ask
                                                                        .text,
                                                                    expression:
                                                                      "ask.text",
                                                                    modifiers: {
                                                                      trim: true
                                                                    }
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "required|max:2000|min:250",
                                                                    expression:
                                                                      "'required|max:2000|min:250'",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                ref:
                                                                  "textMagicWand",
                                                                staticClass:
                                                                  "form-control pt-input field_2",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-2.message"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  id: "message",
                                                                  "aria-label":
                                                                    "What do you need help with? textarea, character count available",
                                                                  "aria-describedby":
                                                                    "char-counter-help",
                                                                  name:
                                                                    "message",
                                                                  required: "",
                                                                  "aria-required":
                                                                    "true",
                                                                  maxlength:
                                                                    _vm.textMax,
                                                                  "data-vv-validate-on":
                                                                    "change|blur|input",
                                                                  rows: "7"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.ask.text
                                                                },
                                                                on: {
                                                                  keyup: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.countdown(
                                                                      "text"
                                                                    )
                                                                  },
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.ask,
                                                                        "text",
                                                                        $event.target.value.trim()
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.ask.text = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ],
                                                                  focus: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleFocusChange(
                                                                      $event
                                                                    )
                                                                  },
                                                                  blur: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _vm.enableMagicWandLF
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "magic-wand-link-textarea-lw magic-wand-link-accent",
                                                                      class: {
                                                                        "magic-wand-link-active": _vm.isExamplesOpen(
                                                                          "text"
                                                                        )
                                                                      },
                                                                      attrs: {
                                                                        role:
                                                                          "button",
                                                                        "aria-label":
                                                                          "View Examples",
                                                                        href:
                                                                          "javascript:void(0);"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.toggleMagicWandExamples(
                                                                            "text"
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " View Examples\n                                                                "
                                                                      ),
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "magic-wand-img magic-wand-img-panel",
                                                                          attrs: {
                                                                            src:
                                                                              _vm.magicWandIcon,
                                                                            alt:
                                                                              "",
                                                                            width:
                                                                              "20",
                                                                            height:
                                                                              "20"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.enableMagicWandLF &&
                                                          _vm.isExamplesOpen(
                                                            "text"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "magic-wand-examples-anchor"
                                                                },
                                                                [
                                                                  _c(
                                                                    "MagicWandExamplesPanel",
                                                                    {
                                                                      attrs: {
                                                                        examples: _vm.getWizardExamplesForField(
                                                                          "text"
                                                                        ),
                                                                        "field-label": _vm.getMagicWandFieldLabel(
                                                                          "text"
                                                                        ),
                                                                        loading:
                                                                          _vm.wizardExamplesLoading,
                                                                        "magic-wand-icon":
                                                                          _vm.magicWandIcon,
                                                                        "accent-color":
                                                                          _vm.magicWandAccentColor,
                                                                        "field-has-text": _vm.magicWandFieldHasText(
                                                                          "text"
                                                                        )
                                                                      },
                                                                      on: {
                                                                        close:
                                                                          _vm.closeMagicWandExamples,
                                                                        "use-example": function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.insertMagicWandExample(
                                                                            "text",
                                                                            $event
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col",
                                                          style:
                                                            _vm.magicWandThemeStyle
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group template-input-text-area template-textarea-v3-t3 magic-wand-icon"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "closeNicely",
                                                                    "aria-label":
                                                                      "Close nicely."
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Close nicely "
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required-symbol"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " *"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    ":\n                                                                "
                                                                  ),
                                                                  _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        "aria-live":
                                                                          "polite",
                                                                        isInteractive: true,
                                                                        content:
                                                                          "Tell the reader that you appreciate their time and help. Example: 'Thank you very much for your insights."
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                      attrs: {
                                                                        id:
                                                                          "closing-description"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Close nicely tooltip: Tell the reader that you appreciate their time and help. Example: 'Thank you very much for your insights."
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-2.closeNicely"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-2.closeNicely')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error-message-textarea error-for-textarea"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-2.closeNicely"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "char-counter-input"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "char-counter-closeNicely",
                                                                        "aria-live":
                                                                          "polite"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.closeNicelyCount
                                                                        ) +
                                                                          " / " +
                                                                          _vm._s(
                                                                            _vm.closeNicelyMax
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "sr-only"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " character count "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("textarea", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model.trim",
                                                                    value:
                                                                      _vm.ask
                                                                        .closeNicely,
                                                                    expression:
                                                                      "ask.closeNicely",
                                                                    modifiers: {
                                                                      trim: true
                                                                    }
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "required|max:500|min:5",
                                                                    expression:
                                                                      "'required|max:500|min:5'",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                ref:
                                                                  "closeNicelyMagicWand",
                                                                staticClass:
                                                                  "form-control pt-input field_1",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-2.closeNicely"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  "aria-label":
                                                                    "Close nicely textarea, character count available",
                                                                  "aria-describedby":
                                                                    "char-counter-closeNicely",
                                                                  id:
                                                                    "closeNicely",
                                                                  required: "",
                                                                  "aria-required":
                                                                    "true",
                                                                  name:
                                                                    "closeNicely",
                                                                  maxlength:
                                                                    _vm.closeNicelyMax,
                                                                  "data-vv-validate-on":
                                                                    "change|blur|input",
                                                                  rows: "3"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.ask
                                                                      .closeNicely
                                                                },
                                                                on: {
                                                                  keyup: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.countdown(
                                                                      "closeNicely"
                                                                    )
                                                                  },
                                                                  focus: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleFocusChange(
                                                                      $event
                                                                    )
                                                                  },
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.ask,
                                                                        "closeNicely",
                                                                        $event.target.value.trim()
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.ask.closeNicely = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ],
                                                                  blur: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _vm.enableMagicWandLF
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "magic-wand-link-textarea-lw magic-wand-link-accent",
                                                                      class: {
                                                                        "magic-wand-link-active": _vm.isExamplesOpen(
                                                                          "closeNicely"
                                                                        )
                                                                      },
                                                                      attrs: {
                                                                        role:
                                                                          "button",
                                                                        "aria-label":
                                                                          "View Examples",
                                                                        href:
                                                                          "javascript:void(0);"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.toggleMagicWandExamples(
                                                                            "closeNicely"
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " View Examples\n                                                                "
                                                                      ),
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "magic-wand-img magic-wand-img-panel",
                                                                          attrs: {
                                                                            src:
                                                                              _vm.magicWandIcon,
                                                                            alt:
                                                                              "",
                                                                            width:
                                                                              "20",
                                                                            height:
                                                                              "20"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.enableMagicWandLF &&
                                                          _vm.isExamplesOpen(
                                                            "closeNicely"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "magic-wand-examples-anchor"
                                                                },
                                                                [
                                                                  _c(
                                                                    "MagicWandExamplesPanel",
                                                                    {
                                                                      attrs: {
                                                                        examples: _vm.getWizardExamplesForField(
                                                                          "closeNicely"
                                                                        ),
                                                                        "field-label": _vm.getMagicWandFieldLabel(
                                                                          "closeNicely"
                                                                        ),
                                                                        loading:
                                                                          _vm.wizardExamplesLoading,
                                                                        "magic-wand-icon":
                                                                          _vm.magicWandIcon,
                                                                        "accent-color":
                                                                          _vm.magicWandAccentColor,
                                                                        "field-has-text": _vm.magicWandFieldHasText(
                                                                          "closeNicely"
                                                                        )
                                                                      },
                                                                      on: {
                                                                        close:
                                                                          _vm.closeMagicWandExamples,
                                                                        "use-example": function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.insertMagicWandExample(
                                                                            "closeNicely",
                                                                            $event
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .disclaimer &&
                                                  _vm.configureFields.disclaimer
                                                    .include &&
                                                  _vm.configureFields.disclaimer
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row mlr0"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group disclaimer"
                                                            },
                                                            [
                                                              _c(
                                                                "md-checkbox",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate.continues",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "disclaimer"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('disclaimer')}`",
                                                                      modifiers: {
                                                                        continues: true
                                                                      }
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-checkbox pt-0",
                                                                  attrs: {
                                                                    tabindex:
                                                                      "1",
                                                                    name:
                                                                      "disclaimer",
                                                                    id:
                                                                      "disclaimer",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "disclaimer"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "data-vv-validate-on":
                                                                      "change"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateDisclaimer()
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .disclaimer,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "disclaimer",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "dynamicFields.disclaimer"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                            " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .configureFields
                                                                          .disclaimer
                                                                          .labelName
                                                                      ) +
                                                                      "\n                                                            "
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "disclaimer"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-2.disclaimer"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-2.disclaimer')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error error-mt-2 template-checkbox-error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-2.disclaimer"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .disclaimer &&
                                                  _vm.configureFields.disclaimer
                                                    .include === false
                                                    ? _c("div", {
                                                        staticClass:
                                                          "template-mb-35"
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "btn-block"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row back-next-step-2 pl-15 pr-15"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-center-xs float-left"
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn_info template-review-edit template-button mb-10",
                                                                  style:
                                                                    _vm.styleEditBtn,
                                                                  attrs: {
                                                                    role:
                                                                      "button"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.goToFirst()
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("Back")]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-center-xs float-right"
                                                            },
                                                            [
                                                              _c(
                                                                "md-button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn_info template-review-submit template-button",
                                                                  style:
                                                                    _vm.styleSubmitBtn,
                                                                  attrs: {
                                                                    type:
                                                                      "submit"
                                                                  }
                                                                },
                                                                [_vm._v("Next")]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isThirdPage &&
                                      _vm.configureFields.interest &&
                                      _vm.configureFields.interest.include
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "interests-header"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Choose 3-5 interests you have."
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "box-sub-heading mb35 custom-content interest-description-display"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.configureFields
                                                        .interest.description
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("fieldset", [
                                                _c(
                                                  "legend",
                                                  { staticClass: "sr-only" },
                                                  [
                                                    _vm._v(
                                                      "Select your interests"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row text-center interest-container"
                                                  },
                                                  _vm._l(
                                                    _vm.randomInterest,
                                                    function(
                                                      randomInterestItem
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: randomInterestItem,
                                                          ref:
                                                            "checkboxMainRef",
                                                          refInFor: true,
                                                          staticClass:
                                                            "col-md-4 col-sm-4 col-xs-6 width100"
                                                        },
                                                        [
                                                          _c(
                                                            "md-checkbox",
                                                            {
                                                              key: randomInterestItem,
                                                              staticClass:
                                                                "my-round-checkbox",
                                                              attrs: {
                                                                value: randomInterestItem,
                                                                name: randomInterestItem,
                                                                "aria-describedby":
                                                                  "interest-desc-" +
                                                                  randomInterestItem
                                                                    .replace(
                                                                      /\s+/g,
                                                                      "-"
                                                                    )
                                                                    .toLowerCase()
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateAriaChecked(
                                                                    randomInterestItem
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.selectedInterestList,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.selectedInterestList = $$v
                                                                },
                                                                expression:
                                                                  "selectedInterestList"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "interest-desc-" +
                                                                      randomInterestItem
                                                                        .replace(
                                                                          /\s+/g,
                                                                          "-"
                                                                        )
                                                                        .toLowerCase()
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      randomInterestItem
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row back-next-step-2 pr-25 pl-25"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center-xs float-left"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn_info template-review-edit template-button mb-10",
                                                          style:
                                                            _vm.styleEditBtn,
                                                          attrs: {
                                                            tabindex: "0",
                                                            role: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.goToSecond()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Back\n                                              "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center-xs float-right"
                                                    },
                                                    [
                                                      _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "btn btn_info template-review-submit template-button",
                                                          style:
                                                            _vm.styleSubmitBtn,
                                                          attrs: {
                                                            type: "submit",
                                                            disabled:
                                                              _vm.loading,
                                                            "aria-label":
                                                              "Next: We're crafting a thoughtful question to present to your advisor. Clickable",
                                                            "aria-busy":
                                                              _vm.loading,
                                                            role: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.goToFourth()
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Next")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isFourthPage && _vm.athenaEnabled
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "closeUp-header",
                                                    tabindex: "-1"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Ready for your close-up?"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.community.content &&
                                              _vm.community.content
                                                .requestFormWizardPage3
                                                ? _c("p", {
                                                    staticClass:
                                                      "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.community.content
                                                          .requestFormWizardPage3
                                                      )
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.loading
                                                ? [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "AthenaQuestionSkeleton",
                                                          {
                                                            attrs: {
                                                              "is-visible":
                                                                _vm.loading
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : [
                                                    _c("hr", {
                                                      staticClass:
                                                        "template-hr-custom"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "about-feedbackreq"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "template-request-review"
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                attrs: {
                                                                  "aria-level":
                                                                    "3",
                                                                  role:
                                                                    "heading",
                                                                  "aria-live":
                                                                    "polite"
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      this.ask
                                                                        .first
                                                                    ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        this.ask
                                                                          .last
                                                                      )
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "fs_15 lh_111",
                                                                  staticStyle: {
                                                                    "font-family":
                                                                      "'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif",
                                                                    "text-align":
                                                                      "left",
                                                                    "font-size":
                                                                      "18px",
                                                                    color:
                                                                      "#000001",
                                                                    "line-height":
                                                                      "22px"
                                                                  },
                                                                  attrs: {
                                                                    role:
                                                                      "Presentation"
                                                                  }
                                                                },
                                                                [
                                                                  _vm
                                                                    .dynamicFields
                                                                    .college ||
                                                                  _vm
                                                                    .dynamicFields
                                                                    .college2 ||
                                                                  _vm.school
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            "aria-live":
                                                                              "polite"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .dynamicFields
                                                                                .college ||
                                                                                _vm
                                                                                  .dynamicFields
                                                                                  .college2 ||
                                                                                _vm.school
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _vm
                                                                    .dynamicFields
                                                                    .year ||
                                                                  _vm
                                                                    .dynamicFields
                                                                    .year2 ||
                                                                  _vm.year
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            "aria-live":
                                                                              "polite"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " (" +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .dynamicFields
                                                                                  .year ||
                                                                                  _vm
                                                                                    .dynamicFields
                                                                                    .year2 ||
                                                                                  _vm.year
                                                                              ) +
                                                                              ")"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _vm.gaiaAnswer &&
                                                            !_vm.isEditing
                                                              ? _c("p", {
                                                                  staticClass:
                                                                    "custom-content",
                                                                  attrs: {
                                                                    "aria-live":
                                                                      "polite"
                                                                  },
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.sanitizeInput(
                                                                        _vm.gaiaFormattedAnswer
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              : _c("textarea", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.gaiaAnswer,
                                                                      expression:
                                                                        "gaiaAnswer"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "custom-content-2 editable-input",
                                                                  attrs: {
                                                                    type:
                                                                      "text",
                                                                    rows: "15",
                                                                    "aria-label":
                                                                      "Edit your question response"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.gaiaAnswer
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.gaiaAnswer =
                                                                        $event.target.value
                                                                    }
                                                                  }
                                                                })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row back-next-step-2 pr-25 pl-25"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-center-xs float-left",
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                  gap: "30px"
                                                                }
                                                              },
                                                              [
                                                                !_vm.isEditing
                                                                  ? _c(
                                                                      "button",
                                                                      {
                                                                        staticClass:
                                                                          "btn btn_info template-review-edit template-button mb-10",
                                                                        style:
                                                                          _vm.styleEditBtn,
                                                                        attrs: {
                                                                          "aria-label": _vm.isUndo
                                                                            ? "Undo"
                                                                            : "Redo",
                                                                          role:
                                                                            "button"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.toggleQuestionVersion()
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                                                            " +
                                                                            _vm._s(
                                                                              _vm.isUndo
                                                                                ? "Undo"
                                                                                : "Redo"
                                                                            ) +
                                                                            "\n                                                                                                "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn_info template-review-edit template-button mb-10",
                                                                    style:
                                                                      _vm.styleEditBtn,
                                                                    attrs: {
                                                                      tabindex:
                                                                        "0",
                                                                      role:
                                                                        "button"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.toggleEdit()
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                    " +
                                                                        _vm._s(
                                                                          _vm.isEditing
                                                                            ? "Save"
                                                                            : "Edit"
                                                                        ) +
                                                                        "\n                                              "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-center-xs float-right"
                                                              },
                                                              [
                                                                [
                                                                  !_vm.isEditing
                                                                    ? _c(
                                                                        "md-button",
                                                                        {
                                                                          staticClass:
                                                                            "btn btn_info template-review-submit template-button",
                                                                          style:
                                                                            _vm.styleSubmitBtn,
                                                                          attrs: {
                                                                            type:
                                                                              "button",
                                                                            "aria-label":
                                                                              "Submit your question.",
                                                                            disabled:
                                                                              _vm.isEditing,
                                                                            "aria-busy":
                                                                              _vm.loading,
                                                                            role:
                                                                              "button"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.save()
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Submit"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ],
                                                              2
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isFourthPage &&
                                      _vm.questionCoachEnabled
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "closeUp-header"
                                                  }
                                                },
                                                [_vm._v("Great Start")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "box-sub-heading mb35 custom-content request-form-title-anchor-tab"
                                                },
                                                [
                                                  _vm._v(
                                                    "We've analyzed your question and have a few suggestions to make sure you'll get a response."
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("hr", {
                                                staticClass:
                                                  "template-hr-custom"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "about-feedbackreq"
                                                },
                                                [
                                                  _vm.questionCoachScore <= 0
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "MidsizeSkeleton",
                                                            {
                                                              attrs: {
                                                                "is-visible": true
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "template-request-review feedback-card",
                                                          style: {
                                                            backgroundColor:
                                                              _vm.feedback
                                                                .color +
                                                              " !important"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "feedback-content"
                                                            },
                                                            [
                                                              _c(
                                                                "h2",
                                                                {
                                                                  staticClass:
                                                                    "coach-header score-header feedback-title"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .feedback
                                                                          .text
                                                                      ) +
                                                                      "\n                                                "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .coachFeedback
                                                                      .guidance
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _vm.coachChecklist
                                                                ? _c(
                                                                    "ul",
                                                                    {
                                                                      staticClass:
                                                                        "feedback-checklist"
                                                                    },
                                                                    _vm._l(
                                                                      _vm.checklistItems,
                                                                      function(
                                                                        item,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "li",
                                                                          {
                                                                            key:
                                                                              item.key,
                                                                            staticClass:
                                                                              "checklist-item",
                                                                            class: {
                                                                              checked:
                                                                                item.checked,
                                                                              unchecked: !item.checked
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "checkbox-icon",
                                                                                class: {
                                                                                  checked:
                                                                                    item.checked
                                                                                }
                                                                              },
                                                                              [
                                                                                item.checked
                                                                                  ? _c(
                                                                                      "svg",
                                                                                      {
                                                                                        attrs: {
                                                                                          width:
                                                                                            "20",
                                                                                          height:
                                                                                            "20",
                                                                                          viewBox:
                                                                                            "0 0 20 20",
                                                                                          fill:
                                                                                            "none",
                                                                                          xmlns:
                                                                                            "http://www.w3.org/2000/svg"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "rect",
                                                                                          {
                                                                                            attrs: {
                                                                                              width:
                                                                                                "20",
                                                                                              height:
                                                                                                "20",
                                                                                              rx:
                                                                                                "4",
                                                                                              fill:
                                                                                                "#10B981"
                                                                                            }
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "path",
                                                                                          {
                                                                                            attrs: {
                                                                                              d:
                                                                                                "M6 10L9 13L14 7",
                                                                                              stroke:
                                                                                                "white",
                                                                                              "stroke-width":
                                                                                                "2",
                                                                                              "stroke-linecap":
                                                                                                "round",
                                                                                              "stroke-linejoin":
                                                                                                "round"
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "svg",
                                                                                      {
                                                                                        attrs: {
                                                                                          width:
                                                                                            "20",
                                                                                          height:
                                                                                            "20",
                                                                                          viewBox:
                                                                                            "0 0 20 20",
                                                                                          fill:
                                                                                            "none",
                                                                                          xmlns:
                                                                                            "http://www.w3.org/2000/svg"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "rect",
                                                                                          {
                                                                                            attrs: {
                                                                                              width:
                                                                                                "20",
                                                                                              height:
                                                                                                "20",
                                                                                              rx:
                                                                                                "4",
                                                                                              fill:
                                                                                                "#E5E7EB",
                                                                                              stroke:
                                                                                                "#D1D5DB",
                                                                                              "stroke-width":
                                                                                                "1"
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "checklist-text",
                                                                                class: {
                                                                                  "text-muted": !item.checked
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.label
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.coachChecklist &&
                                                              !_vm.isMessageReady &&
                                                              _vm.coachFeedback
                                                                .improvements &&
                                                              _vm.coachFeedback
                                                                .improvements
                                                                .length
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "improvements-section"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h3",
                                                                        {
                                                                          staticClass:
                                                                            "improvements-title"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Suggestions to improve:"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "ul",
                                                                        {
                                                                          staticClass:
                                                                            "improvements-list"
                                                                        },
                                                                        _vm._l(
                                                                          _vm
                                                                            .coachFeedback
                                                                            .improvements,
                                                                          function(
                                                                            improvement,
                                                                            index
                                                                          ) {
                                                                            return _c(
                                                                              "li",
                                                                              {
                                                                                key:
                                                                                  "improvement-" +
                                                                                  index,
                                                                                staticClass:
                                                                                  "improvement-item"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                            " +
                                                                                    _vm._s(
                                                                                      improvement
                                                                                    ) +
                                                                                    "\n                                                        "
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "feedback-emoji-wrapper"
                                                            },
                                                            [
                                                              _vm.coachChecklist
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "score-circle"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "svg",
                                                                        {
                                                                          attrs: {
                                                                            width:
                                                                              "80",
                                                                            height:
                                                                              "80",
                                                                            viewBox:
                                                                              "0 0 80 80"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "circle",
                                                                            {
                                                                              attrs: {
                                                                                cx:
                                                                                  "40",
                                                                                cy:
                                                                                  "40",
                                                                                r:
                                                                                  "35",
                                                                                fill:
                                                                                  "white",
                                                                                stroke:
                                                                                  "#E5E7EB",
                                                                                "stroke-width":
                                                                                  "2"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "text",
                                                                            {
                                                                              attrs: {
                                                                                x:
                                                                                  "40",
                                                                                y:
                                                                                  "45",
                                                                                "text-anchor":
                                                                                  "middle",
                                                                                "font-size":
                                                                                  "24",
                                                                                "font-weight":
                                                                                  "bold",
                                                                                fill:
                                                                                  "#1F2937"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                            " +
                                                                                  _vm._s(
                                                                                    _vm.checklistCompletionCount
                                                                                  ) +
                                                                                  "/" +
                                                                                  _vm._s(
                                                                                    _vm.checklistTotalCount
                                                                                  ) +
                                                                                  "\n                                                        "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "text",
                                                                            {
                                                                              attrs: {
                                                                                x:
                                                                                  "40",
                                                                                y:
                                                                                  "58",
                                                                                "text-anchor":
                                                                                  "middle",
                                                                                "font-size":
                                                                                  "10",
                                                                                fill:
                                                                                  "#6B7280"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                            COMPLETE\n                                                        "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "feedback-emoji big-emoji"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .feedback
                                                                            .emoji
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "feedback-text-emoji"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .feedback
                                                                        .text_emoji
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "coachDraftText"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Edit your message below - and review changes"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.coachDraft,
                                                        expression: "coachDraft"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "editable-input custom-content-2",
                                                    staticStyle: {
                                                      "text-align": "justify"
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "coachDraftText",
                                                      rows: "15",
                                                      "aria-label":
                                                        "Edit your question response"
                                                    },
                                                    domProps: {
                                                      value: _vm.coachDraft
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.coachDraft =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "back-next-step-2",
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",
                                                        "align-items": "center",
                                                        gap: "10px",
                                                        "flex-wrap": "nowrap"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn_info template-review-edit template-button",
                                                          style:
                                                            _vm.styleEditBtn,
                                                          attrs: {
                                                            role: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.communityHasInterests
                                                                ? _vm.goToThird()
                                                                : _vm.goToSecond()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                Back\n                                            "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            gap: "10px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-edit template-button",
                                                              style:
                                                                _vm.styleEditBtn,
                                                              attrs: {
                                                                role: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.questionCoach()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                Review\n                                            "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "md-button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-submit template-button",
                                                              style:
                                                                _vm.styleSubmitBtn,
                                                              attrs: {
                                                                type: "button",
                                                                disabled: !_vm.isMessageReady
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.save()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                Submit\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm.isFourthPage && !_vm.athenaEnabled
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "closeUp-header",
                                                    "aria-level": "1"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Ready for your close-up?"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.community.content &&
                                              _vm.community.content
                                                .requestFormWizardPage3
                                                ? _c("p", {
                                                    staticClass:
                                                      "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.community.content
                                                          .requestFormWizardPage3
                                                      )
                                                    }
                                                  })
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "box-sub-heading mb35 custom-content request-form-title-anchor-tab"
                                                    },
                                                    [
                                                      _vm._v(
                                                        'Here\'s what advisors will receive. Need to make a revision? Simply click "Back" and edit.'
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c("hr", {
                                                staticClass:
                                                  "template-hr-custom"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "about-feedbackreq"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "template-request-review"
                                                    },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          attrs: {
                                                            "aria-level": "2",
                                                            role: "Presentation"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask.first
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                this.ask.last
                                                              )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "fs_15 lh_111",
                                                            staticStyle: {
                                                              "font-family":
                                                                "'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif",
                                                              "text-align":
                                                                "left",
                                                              "font-size":
                                                                "18px",
                                                              color: "#000001",
                                                              "line-height":
                                                                "22px"
                                                            },
                                                            attrs: {
                                                              role:
                                                                "Presentation"
                                                            }
                                                          },
                                                          [
                                                            _vm.dynamicFields
                                                              .college ||
                                                            _vm.dynamicFields
                                                              .college2 ||
                                                            _vm.school
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .dynamicFields
                                                                        .college ||
                                                                        _vm
                                                                          .dynamicFields
                                                                          .college2 ||
                                                                        _vm.school
                                                                    )
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.dynamicFields
                                                              .year ||
                                                            _vm.dynamicFields
                                                              .year2 ||
                                                            _vm.year
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " (" +
                                                                      _vm._s(
                                                                        _vm
                                                                          .dynamicFields
                                                                          .year ||
                                                                          _vm
                                                                            .dynamicFields
                                                                            .year2 ||
                                                                          _vm.year
                                                                      ) +
                                                                      ")"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "h2",
                                                        {
                                                          attrs: {
                                                            "aria-level": "2",
                                                            role: "Presentation"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask.subject
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "font-color"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(this.ask.bio)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "font-color"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask.text
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "font-color"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask
                                                                .closeNicely
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row back-next-step-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-6 text-center-xs float-left"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-edit template-button mb-10",
                                                              style:
                                                                _vm.styleEditBtn,
                                                              attrs: {
                                                                role: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.communityHasInterests
                                                                    ? _vm.goToThird()
                                                                    : _vm.goToSecond()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Back")]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-6 text-center-xs float-right text-right-md"
                                                        },
                                                        [
                                                          _c(
                                                            "md-button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-submit template-button",
                                                              style:
                                                                _vm.styleSubmitBtn,
                                                              attrs: {
                                                                type: "button",
                                                                disabled:
                                                                  _vm.disabledBtn ==
                                                                  1
                                                                    ? true
                                                                    : false
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.save()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Submit")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isBeforeRequest && !_vm.invalidMember
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation"
                                  },
                                  [
                                    _c("h1", { staticClass: "sr-only" }, [
                                      _vm._v("So what's next?")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "h1",
                                      {
                                        staticClass:
                                          "box-heading thankyou-template-title",
                                        attrs: {
                                          id: "whatsnext-header",
                                          "aria-hidden": "true"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    So what's next?\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { color: "#000001" } },
                                      [
                                        _vm.community.content &&
                                        _vm.community.content
                                          .requestPageThankYou
                                          ? _c("div", {
                                              staticClass:
                                                "box-sub-heading text-left content-textleft thankyou-custom-content",
                                              attrs: { tabindex: "0" },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.community.content
                                                    .requestPageThankYou
                                                )
                                              },
                                              on: {
                                                "!click": function($event) {
                                                  return _vm.handleThankYouResourceClick.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "box-sub-heading text-left content-textleft thankyou-custom-content",
                                                staticStyle: {
                                                  color: "#000001"
                                                },
                                                attrs: { tabindex: "0" }
                                              },
                                              [
                                                _vm._v(
                                                  "We will now recruit the right experts to help you."
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _vm.isLoadingResources
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "thankyou-loader-wrapper mt-4",
                                                attrs: { "aria-live": "polite" }
                                              },
                                              [
                                                _c("CustomThankYou", {
                                                  attrs: { isVisible: true }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showErrorMessage
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "thankyou-status-message mt-4",
                                                staticStyle: {
                                                  padding: "12px 16px",
                                                  "border-radius": "4px",
                                                  border: "1px solid #f5c2c7",
                                                  background: "#f8d7da",
                                                  color: "#611a15"
                                                },
                                                attrs: {
                                                  role: "alert",
                                                  tabindex: "0"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.errorMessage ||
                                                        "We were unable to submit your request. Please try again."
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showSuccessMessage
                                          ? _c(
                                              "div",
                                              { staticClass: "mt-4 text-left" },
                                              [
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn_info template-review-submit template-button",
                                                    style: _vm.styleSubmitBtn,
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click:
                                                        _vm.askAnotherQuestion
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            Ask Another Question\n                                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isBeforeRequest && _vm.invalidMember
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "header-text common-space-from-logo text-left unsubscribepage-thankumsg",
                                    attrs: { tabindex: "0" }
                                  },
                                  [
                                    _c(
                                      "h1",
                                      {
                                        staticClass:
                                          "box-heading thankyou-template-title",
                                        attrs: {
                                          role: "alert",
                                          "aria-live": "Assertive"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Ooops. We’re really sorry\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.community.content &&
                                    _vm.community.content.requestPageThankYou
                                      ? _c("div", {
                                          staticClass:
                                            "box-sub-heading text-left content-textleft thankyou-custom-content",
                                          attrs: { tabindex: "0" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.finalInvalidMemberMessage
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("footer", [
                      _c(
                        "ul",
                        { staticClass: "list-inline text-center footer-links" },
                        [
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.landingPageURL &&
                            _vm.community.content.landingPageURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content.landingPageURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.termsConditionsURL &&
                            _vm.community.content.termsConditionsURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content
                                          .termsConditionsURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.unsubscribePageURL &&
                            _vm.community.content.unsubscribePageURL.length
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      tabindex: "0",
                                      href:
                                        _vm.community.content
                                          .unsubscribePageURL,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Opt Out")]
                                )
                              : _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0)" } },
                                  [_vm._v("Opt Out")]
                                )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "unsubscribe-community-logo" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                (_vm.community.content &&
                                  _vm.community.content.landingPageURL) ||
                                "https://www.protopia.co",
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm.footerLogoURL,
                                alt:
                                  "Community Logo of " +
                                  (_vm.community &&
                                  _vm.community.content &&
                                  _vm.community.content.parameter4
                                    ? _vm.community.content.parameter4
                                    : (_vm.community && _vm.community.name) ||
                                      "Community")
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Protopia - Visit our site")
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9ce2076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9ce2076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunityRequestPage.vue
// module id = null
// module chunks = 